import React, { useState, useEffect, useContext } from "react";
import InternalPageHeader from "../../components/media/InternalPageHeader";
import ImgTextCardAlt from "../../components/media/ImgTextCardAlt";
import ArticleText from "../../components/text/ArticleText";
import { Container, Row, Col, Accordion } from "react-bootstrap";
import bgInternalImage from "../../images/MLK-Memorial-Garden-2-cropped.jpg";
import Footer from "../../components/Footer";
import ReactPaginate from "react-paginate";
import Button from "react-bootstrap/Button";
import Dropdown from "react-bootstrap/Dropdown";
import { inMemoriamContext } from "../../contexts/InMemoriamContext";
import { Skeleton } from "@mui/material";

const InMemoriamLocationFilter = () => {
  const { inMemoriamData, loading } = useContext(inMemoriamContext);
  const [filterLocation, setFilterLocation] = useState("All Locations");
  const [filterType, setFilterType] = useState("All Victims");
  const [currentPage, setCurrentPage] = useState(0);
  const [pageCount, setPageCount] = useState(0);
  const [perPage, setPerPage] = useState(20);
  const [offset, setOffset] = useState(0);
  const [data, setData] = useState([]);
  const [isMemoiramDataLoading, setIsMemoriamDataLoading] = useState(true);
  const [filterList, setFilterList] = useState([]);

  const inMemoriamSkeletonTiles = Array.from({ length: 4 }).map((_, index) => (
    <Col key={index} md={6} lg={4} xl={3}>
      <div
        style={{
          margin: "1rem 0.75rem",
          boxShadow: "1px 1px 8px rgba(0, 0, 0, 0.35)",
          backgroundColor: "#f8f9fa",
          border: "none",
          borderRadius: "0px",
        }}
      >
        {/* Image section with progress indicator */}
        <div
          style={{
            height: "16rem",
            background: `linear-gradient(
            rgba(224, 224, 224, 0),
            rgba(189, 189, 189, 0.5),
            rgba(158, 158, 158, 0.85)
          )`,
            backgroundSize: "cover",
            backgroundRepeat: "no-repeat",
            backgroundPosition: "center",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <Skeleton
            variant="rectangle"
            animation="wave"
            height={"16em"}
            width="100%"
          />
        </div>

        {/* Text section */}
        <div style={{ padding: "1rem" }}>
          <Skeleton
            variant="text"
            animation="wave"
            height={20}
            width="80%"
            style={{ marginTop: 10 }}
          />
          <Skeleton
            variant="text"
            animation="wave"
            height={18}
            width="60%"
            style={{ marginTop: 10 }}
          />
          <Skeleton
            variant="text"
            animation="wave"
            height={18}
            width="40%"
            style={{ marginTop: 10 }}
          />
        </div>
      </div>
    </Col>
  ));

  useEffect(() => {
    if (inMemoriamData) {
      processInMemoriamData();
    }
  }, [
    inMemoriamData,
    loading,
    offset,
    currentPage,
    filterLocation,
    filterType,
  ]);

  const handleLocationFilter = (filterApplied) => {
    setFilterLocation(filterApplied);
    // console.log("in handle location");
    handlePageClick(0);
  };
  const handleTypeFilter = (filterApplied) => {
    setFilterType(filterApplied);
    setFilterLocation("All Locations");
    // console.log("in handle type");
    handlePageClick(0);
  };

  const handlePageClick = (selectedPage) => {
    const offset = selectedPage * perPage;
    setCurrentPage(selectedPage);
    setOffset(offset);
  };

  const processInMemoriamData = () => {
    const data = inMemoriamData;
    let filteredItems = [];
    let typeFilterdData = [];
    typeFilterdData = data;

    typeFilterdData = data.filter((item) =>
      filterType === "All Victims" ? item : item.Type === filterType
    );
    filteredItems = typeFilterdData.filter((item) =>
      filterLocation === "All Locations" ? item : item.Group === filterLocation
    );

    // console.log("tfd", typeFilterdData);
    // console.log("fi", filteredItems);
    const sliced = filteredItems.slice(offset, offset + perPage);
    const mappedData = sliced.map((memoriam) => (
      <Col key={memoriam.id} md={6} lg={4} xl={3}>
        <ImgTextCardAlt
          personName={`Name: ${memoriam.NameOfPerson}`}
          hometown={`Town: ${memoriam.Town}`}
          dateOfDeath={`Year: ${memoriam.BYDATE}`}
        />
      </Col>
    ));
    const locations = [...new Set(typeFilterdData.map((item) => item.Group))];

    // console.log("asdf",locations);

    setFilterList(locations);
    setData(mappedData);
    setIsMemoriamDataLoading(false);
    setPageCount(Math.ceil(filteredItems.length / perPage));
  };

  return (
    <main className="inMemoriamFilter">
      <InternalPageHeader
        pageHeading={"In Memoriam"}
        pageSubHeading={"Honoring Those Who Came Before Us"}
        inPageBGImage={bgInternalImage}
      />
      <ArticleText
        articleText={`The ACCRP honors the victims of racial terror in Alachua County, those known and unknown.`}
      />
      <ArticleText
        articleText={`During the Jim Crow Era, lynchings went widely unreported. In some cases, local newspapers didn’t even report the names of the victims they wrote about. Newspapers and court records that do exist, give some insight into the deaths of these individuals but tell nothing about who they were in life.`}
      />
      <ArticleText
        articleText={`We may never know about the full lives of each of the victims of racial terror lynching, but we do know that they were fathers, mothers, sisters, brothers, sons, daughters, aunts and uncles, and the relatives of descendants within our community. We honor their lives and their memories through our efforts to tell the truth about this painful history. Although we do not know their life stories, we know that many were targeted for their role as community leaders, organizers, and landowners.`}
      />

      <div className="siteContainerHolder">
        <Container className="holdSites" style={{ paddingTop: "2%" }}>
          <Row style={{ display: "flex" }}>
            <Col
              className="filtering-buttons"
              xs={12}
              lg={3}
              style={{ fontFamily: "Source Sans Pro", display: "flex" }}
            >
              <Dropdown style={{ marginRight: "2%" }}>
                <Dropdown.Toggle
                  style={{
                    backgroundColor: "#00283C",
                    color: "white",
                    borderColor: "black",
                  }}
                  id="dropdown-basic"
                >
                  Type Filter
                </Dropdown.Toggle>
                <Dropdown.Menu>
                  <Dropdown.Item
                    onClick={() => handleTypeFilter("All Victims")}
                    href="#/action-1"
                  >
                    All Victims
                  </Dropdown.Item>
                  <Dropdown.Item
                    onClick={() => handleTypeFilter("Lynchings")}
                    href="#/action-2"
                  >
                    Lynching Victims
                  </Dropdown.Item>
                  <Dropdown.Item
                    onClick={() => handleTypeFilter("Racial Injustice")}
                    href="#/action-1"
                  >
                    Racial Injustice Victims
                  </Dropdown.Item>
                </Dropdown.Menu>
              </Dropdown>

              <Dropdown style={{ marginLeft: "2%" }}>
                <Dropdown.Toggle
                  style={{
                    backgroundColor: "#00283C",
                    color: "white",
                    borderColor: "black",
                  }}
                  id="dropdown-basic"
                >
                  Location Filter
                </Dropdown.Toggle>
                <Dropdown.Menu>
                  {filterList.map((section, index) => (
                    <Dropdown.Item
                      key={index}
                      onClick={() => handleLocationFilter(section)}
                      href={`#/action-${index + 1}`}
                    >
                      {section}
                    </Dropdown.Item>
                  ))}
                </Dropdown.Menu>
              </Dropdown>
            </Col>
            <Col className="filtering-tagline" xs={12} lg={8}>
              <h4 style={{ textAlign: "center" }}>
                You are currently viewing{" "}
                <span style={{ color: "#00283C", textDecoration: "underline" }}>
                  {filterType}
                </span>{" "}
                in{" "}
                <span style={{ color: "#00283C", textDecoration: "underline" }}>
                  {filterLocation}
                </span>{" "}
                in Alachua County
              </h4>
            </Col>
            <Col
              className="reset-button"
              xs={12}
              lg={1}
              style={{ fontFamily: "Source Sans Pro", display: "flex" }}
            >
              <Button
                style={{
                  backgroundColor: "#00283C",
                  color: "white",
                  borderColor: "black",
                }}
                onClick={() => handleTypeFilter("All Victims")}
              >
                Reset
              </Button>
            </Col>
          </Row>
          <Row>
            <Row>
              {isMemoiramDataLoading ? inMemoriamSkeletonTiles : data}
              <ReactPaginate
                previousLabel={"Prev"}
                nextLabel={"Next"}
                breakLabel={"..."}
                breakClassName={"break-me"}
                pageCount={pageCount}
                marginPagesDisplayed={2}
                pageRangeDisplayed={5}
                onPageChange={(e) => handlePageClick(e.selected)}
                containerClassName={"pagination"}
                subContainerClassName={"pages pagination"}
                activeClassName={"active"}
                forcePage={currentPage}
              />
            </Row>
          </Row>
        </Container>
      </div>
      <Footer />
    </main>
  );
};

export default InMemoriamLocationFilter;
